// Pure builder for the post-assign confirmation toast (spec §3).
//
// Assigning a meeting to a project tops up that project's attendee +
// glossary lists. After a successful assign we surface a quiet, non-
// blocking summary of what was newly added. When nothing new landed
// (everything already deduped against existing rows/aliases), we say so
// rather than claiming "0 people + 0 terms".
//
// Kept pure (no React, no DOM) so the singular/plural + zero-case logic
// is unit-testable in isolation.

export function promotionToastText(
  attendeesPromoted: number,
  termsPromoted: number,
  projectName: string,
): string {
  // Omit a side that added nothing rather than say "0 people". Also gracefully
  // handles missing counts (undefined > 0 is false) → "nothing new to add".
  const parts: string[] = [];
  if (attendeesPromoted > 0) {
    parts.push(`${attendeesPromoted} ${attendeesPromoted === 1 ? "person" : "people"}`);
  }
  if (termsPromoted > 0) {
    parts.push(`${termsPromoted} ${termsPromoted === 1 ? "term" : "terms"}`);
  }
  if (parts.length === 0) {
    return "Assigned — nothing new to add.";
  }
  return `Added ${parts.join(" + ")} to ${projectName}.`;
}
